<template>
    <div>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Van Load Fife Feedback Form</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field label="Your Name*" v-model="customer_name" filled required></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field label="Your Email*" type="email" v-model="customer_email"
                                              filled required></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea label="Your Review / Feedback*" type="text" v-model="customer_review"
                                            filled required></v-textarea>
                            </v-col>
                            <v-select :items="rating_options" v-model="customer_rating" label="Your Star Rating 1-5*"
                                      filled
                                      required></v-select>
                        </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text v-on:click="submitFeedback">Submit Feedback</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <Snackbar :modal="thanks_snackbar" color="pink"
                  text="Your feedback has been submitted. Thanks for providing feedback!"
                  v-on:close-snackbar="closeThanksSnackbar"/>
        <Snackbar :modal="error_snackbar" color="pink"
                  text="An unexpected error has occurred. Please refresh the page and try again."
                  v-on:close-snackbar="closeErrorSnackbar"/>
    </div>
</template>

<script>
    import db from '../config/firebaseInit'
    import Snackbar from '../components/Snackbar.vue';

    export default {
        name: 'FeedbackForm',
        components: {Snackbar},
        data() {
            return {
                dialog: true,
                customer_name: '',
                customer_email: '',
                customer_review: '',
                customer_rating: null,
                rating_options: [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5
                ],
                thanks_snackbar: false,
                error_snackbar: false
            };
        },
        methods: {
            submitFeedback() {
                const ref = db.collection('customer-submitted-reviews').doc();
                db.collection('customer-submitted-reviews').add({
                    review_id: ref.id,
                    customer_name: this.customer_name,
                    customer_email: this.customer_email,
                    customer_review: this.customer_review,
                    rating: this.customer_rating,
                    submitted: new Date()
                }).then(() => {
                    this.thanks_snackbar = true;
                }).catch(error => {
                    console.error('Error adding review: ', error)
                    this.error_snackbar = true;
                });
            },
            closeThanksSnackbar() {
                this.thanks_snackbar = false;
            },
            closeErrorSnackbar() {
                this.error_snackbar = false;
            }
        },
    };
</script>

<style scoped>

</style>
